



















import Base from "@/controllers/base.ts";
import { Component, Prop } from "vue-property-decorator";
import { Input, Button } from "ant-design-vue";
import CModal from "@/components/CModal/index.vue";
import CSendCode from "@/components/CSendCode/index.vue";

@Component({
  name: "Safe",
  components: {
    CModal,
    CSendCode,
    AButton: Button,
    AInput: Input
  }
})
export default class EditMobile extends Base {
  // text, button
  @Prop({ default: "text" }) type!: string;

  private visible = false;
  private code = "";
  private uuid = "";
  private phonenumber = "";

  /**
   * 0: 旧手机验证码发送
   * 1: 新手机验证码，以及手机号填写
   */
  private step = 0;

  private beforeSave() {
    this.$message.destroy();
    if (!this.phonenumber || !this.$tools.checkPhone(this.phonenumber)) {
      this.$message.error("您的手机号码格式不正确");
      return false;
    }

    if (!this.uuid) {
      this.$message.error("请先发送验证码");
      return false;
    }

    if (!this.code) {
      this.$message.error("请填写验证码");
      return false;
    }

    return true;
  }

  private async save() {
    if (this.beforeSave()) {
      const res = await this.$api.UpdatePhonenumber({
        phonenumber: this.phonenumber,
        code: this.code,
        uuid: this.uuid
      });

      if (res && res.code === 200) {
        this.updateUser(true);
        this.visible = false;
        this.close();
        this.$message.success("修改成功");
      }
    }
  }

  /**
   * 修改手机号的时候，第一步先填写旧手机收到的验证码，进行校验
   */
  private async codeVerify() {
    if (!this.uuid) {
      this.$message.error("请先发送验证码");
      return false;
    }

    if (!this.code) {
      this.$message.error("请填写验证码");
      return false;
    }

    const res = await this.$api.CodeVerify({
      phonenumber: this.currentUser.phonenumber,
      code: this.code,
      uuid: this.uuid
    });

    if (res && res.code === 200) {
      this.uuid = "";
      this.code = "";
      this.step = 1;
    }
  }

  private ok() {
    if (this.step === 0) {
      this.codeVerify();
    } else {
      this.save();
    }
  }

  private close() {
    this.init();
  }

  /**
   * 发送完短信验证码后的回调函数，用来获取接口返回的相关数据
   */
  private getCodeInfo(obj: any) {
    this.uuid = obj.uuid;
  }

  // 初始化修改手机弹框
  private init() {
    this.step = 0;
  }
}
